import React from 'react';
import './ticker.css';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const Ticker = ({ children }) => {
  const theme = useTheme();
  const items = React.Children.toArray(children).filter(Boolean);
  const shouldAnimate = items.length > 1;
  const duration = Math.max(18, items.length * 8);
  const gap = theme.spacing(2);

  const renderGroup = (groupKey) => (
    <Box
      key={groupKey}
      className="ticker-group"
      sx={{
        display: 'flex',
        alignItems: 'stretch',
        flexShrink: 0,
        gap,
        pr: gap
      }}>
      {items.map((child, index) => (
        <Box key={`${groupKey}-${index}`} sx={{ flex: '0 0 auto' }}>
          {child}
        </Box>
      ))}
    </Box>
  );

  return (
    <Box
      className="ticker-container"
      sx={{
        width: '100%',
        overflow: 'hidden',
        py: 1
      }}>
      <Box
        className="ticker-track"
        sx={{
          display: 'flex',
          alignItems: 'stretch',
          width: 'max-content',
          animation: shouldAnimate ? `ticker-marquee ${duration}s linear infinite` : 'none'
        }}>
        {renderGroup('primary')}
        {shouldAnimate && renderGroup('duplicate')}
      </Box>
    </Box>
  );
};

export default Ticker;
